import React from 'react';
import PropTypes from 'prop-types';
import { Form, connectField, connectSubmit } from 'onion-form';
import { Col, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import * as validators from '../../../common/validators';
import BasicFormField from '../components/basic_form_field';
import CheckboxFieldComponent from '../components/checkbox_field_component';
import DateFieldComponent from '../components/date_field_component';

import { submitOrder } from './actions';
import OrderProgress from './progress';

const Email = connectField('email', { type: 'email' })(BasicFormField);
const School = connectField('school')(BasicFormField);
const City = connectField('city')(BasicFormField);
const Address = connectField('address')(BasicFormField);
const Year = connectField('year')(BasicFormField);
const Students = connectField('students')(BasicFormField);
const Phone = connectField('phone')(BasicFormField);
const Name = connectField('name')(BasicFormField);
const Projector = connectField('projector')(CheckboxFieldComponent);
const Wifi = connectField('wifi')(CheckboxFieldComponent);
const Privacy = connectField('privacy')(CheckboxFieldComponent);
const Submit = connectSubmit(props => <button {...props}>{props.children}</button>);

const Date1 = connectField('date1')(DateFieldComponent);
const Date2 = connectField('date2')(DateFieldComponent);
const Date3 = connectField('date3')(DateFieldComponent);


@connect(null, { submitOrder })
export default class OrderForm extends React.Component {
  static propTypes = {
    submitOrder: PropTypes.func.isRequired
  };

  handleSubmit({ values }) {
    this.props.submitOrder(values);
  }

  render() {
    return (
      <div>
        <OrderProgress active={3} />
        <h1>Vyplňte kontaktní údaje</h1>

        <Well data-tid="order-form">
          <Form name="order" onSubmit={this.handleSubmit.bind(this)}>
            <h2>Údaje o žácích a škole</h2>
            <Row>
              <Col md={6}><School required label="Škola" validations={[validators.isRequired]} /></Col>
              <Col md={6}><City required label="Město" validations={[validators.isRequired]} /></Col>
            </Row>
            <Row>
              <Col md={12}><Address required label="Adresa, kde bude workshop probíhat" validations={[validators.isRequired]} /></Col>
            </Row>
            <Row>
              <Col md={6}><Year required label="Ročník studia" validations={[validators.isRequired]} /></Col>
              <Col md={6}><Students required label="Přibližný počet žáků" validations={[validators.isRequired]} /></Col>
            </Row>
            <Row>
              <Col md={12}><Projector>Možnost promítání</Projector></Col>
            </Row>
            <Row>
              <Col md={12}><Wifi>Možnost připojit se se žáky na mobilních telefonech ke školní Wi-Fi</Wifi></Col>
            </Row>
            <h2>Kontaktní údaje</h2>
            <Row>
              <Col md={12}><Name required label="Vaše jméno a příjmení" validations={[validators.isRequired]} /></Col>
            </Row>
            <Row>
              <Col md={6}><Email required label="Váš email" validations={[validators.isRequired, validators.isEmail]} /></Col>
              <Col md={6}><Phone required label="Vaše telefonní číslo" validations={[validators.isRequired]} /></Col>
            </Row>

            <h2>Vyberte vhodné termíny</h2>
            Vyberte, prosím, max. tři termíny, které Vám pro workshop vyhovují.
            <Row>
              <Col md={4}><Date1 required label="Termín 1" validations={[validators.isRequired, validators.isDateTime]} /></Col>
              <Col md={4}><Date2 label="Termín 2" /></Col>
              <Col md={4}><Date3 label="Termíny 3" /></Col>
            </Row>
            <Row>
              <Col md={12}>
                <Privacy required validations={[validators.isRequired]}>Souhlasím se zpracováním osobních údajů podle <Link to="/zasady-osobnich-udaju" target="_blank">Zásad zpracování osobních údajů</Link>.</Privacy>
              </Col>
            </Row>
            <Submit className="btn btn-primary">Odeslat objednávku</Submit>
          </Form>
        </Well>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/order/form.jsx